/*
 *
 * FlowwiseLayout constants
 *
 */

import React from 'react';
import { ICON_NAME } from 'components/CustomIcons/types';

import { PG_DASHBOARD_MENU_URL_MAPPING } from '../../utils/constants';
// import { ICON_NAME } from 'components/CustomIcons/types';
import CustomIcons from '../../components/CustomIcons';

export const DEFAULT_ACTION = 'app/FlowwiseLayout/DEFAULT_ACTION';

export const FLOWWISE_INACTIVE_PRODUCTS = {
  features: {
    items: [
      {
        rank: 1,
        key: 'flowwise',
        icon: iconProps => (
          <CustomIcons componentName={ICON_NAME.FLOWWISE} {...iconProps} />
        ),
        displayText: 'flowWise',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  subProducts: [
    {
      label: '',
      items: [
        {
          rank: 1,
          key: 'insights-ai',
          icon: iconProps => (
            <CustomIcons componentName={ICON_NAME.INSIGHTS_AI} {...iconProps} />
          ),
          displayText: 'InsightsAI',
          isNew: false,
          isDisabled: false,
          isVisible: true,
          isParent: false,
        },
      ],
    },
  ],
};

export const FEATURE_ITEMS = [
  {
    rank: 1,
    key: 'analytics',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ROUTER_ANALYTICS} {...iconProps} />
    ),
    displayText: 'Analytics',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 2,
    key: 'gateways',
    icon: iconProps => (
      <CustomIcons componentName={ICON_NAME.ROUTER_GATEWAYS} {...iconProps} />
    ),
    displayText: 'Gateways',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 3,
    key: 'configurations',
    icon: iconProps => (
      <CustomIcons
        componentName={ICON_NAME.ROUTER_CONIGURATION}
        {...iconProps}
      />
    ),
    displayText: 'Configurations',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const SUB_PRODUCTS = [
  {
    label: 'PAYMENTS',
    items: [
      {
        rank: 2,
        key: 'transactions',
        icon: iconProps => (
          <CustomIcons componentName={ICON_NAME.TRANSACTIONS} {...iconProps} />
        ),
        displayText: 'Transactions',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: true,
        children: [
          {
            rank: 2,
            key: 'transactions/orders',
            displayText: 'Orders',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 4,
            key: 'transactions/disputes',
            displayText: 'Disputes',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
            children: [],
          },
          {
            rank: 1,
            key: 'transactions/payments',
            displayText: 'Payments',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
            children: [],
          },
          {
            rank: 3,
            key: 'transactions/refunds',
            displayText: 'Refunds',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 5,
            key: 'transactions/suspicious',
            displayText: 'Suspicious',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
            children: [],
          },
        ],
      },
      {
        rank: 3,
        key: 'settlement-recon',
        icon: iconProps => (
          <CustomIcons componentName="SETTLEMENT_RECON" {...iconProps} />
        ),
        displayText: 'Reconciliation',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 4,
        key: 'payment-links',
        icon: iconProps => (
          <CustomIcons componentName="PAYMENT_LINKS" {...iconProps} />
        ),
        displayText: 'Payment Links',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: true,
        children: [
          {
            rank: 1,
            key: 'payment-links/all',
            displayText: 'All',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 2,
            key: 'payment-links/orders',
            displayText: 'Orders',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 3,
            key: 'payment-links/batch',
            displayText: 'Batch',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
        ],
      },
      {
        rank: 10,
        key: 'risk-shield',
        icon: iconProps => (
          <CustomIcons componentName="RISKSHIELD" {...iconProps} />
        ),
        displayText: 'RiskShield',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: true,
        children: [
          {
            displayText: 'Overview',
            name: 'overview',
            rank: 1,
            key: 'risk-shield/overview',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            displayText: 'Risky Transactions',
            name: 'risky-transactions',
            rank: 2,
            key: 'risk-shield/risky-transactions',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            displayText: 'Smart Rules',
            name: 'configurations',
            rank: 3,
            key: 'risk-shield/configurations',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            displayText: 'My Blacklists',
            name: 'my-blacklists',
            rank: 4,
            key: 'risk-shield/blacklists',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
        ],
      },
      {
        rank: 11,
        key: 'customisation',
        icon: iconProps => (
          <CustomIcons
            componentName={ICON_NAME.CHECKOUT_CUSTOMISATIONS}
            {...iconProps}
          />
        ),
        displayText: 'Customisation',
        hideHeader: true,
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
      {
        rank: 12,
        key: 'reports',
        icon: iconProps => (
          <CustomIcons componentName="REPORTS" {...iconProps} />
        ),
        displayText: 'Reports',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: true,
        children: [
          {
            rank: 1,
            key: 'reports/download',
            displayText: 'Download Reports',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 2,
            key: 'reports/schedule',
            displayText: 'Schedule Reports',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
        ],
      },
    ],
  },
  {
    label: '',
    items: [
      {
        rank: 12,
        key: 'insights-ai',
        icon: iconProps => (
          <CustomIcons componentName="INSIGHTS_AI" {...iconProps} />
        ),
        displayText: 'InsightsAI',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: false,
      },
    ],
  },
  {
    label: '',
    items: [
      {
        rank: 13,
        key: 'developers',
        icon: iconProps => (
          <CustomIcons componentName="DEVELOPERS" {...iconProps} />
        ),
        displayText: 'Developers',
        isNew: false,
        isDisabled: false,
        isVisible: true,
        isParent: true,
        children: [
          {
            rank: 1,
            key: 'developers/api-keys',
            displayText: 'API Keys',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 2,
            key: 'developers/api-metrics',
            displayText: 'API Logs and Alerts',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 3,
            key: 'developers/webhooks',
            displayText: 'Webhooks',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 4,
            key: 'developers/rate-limits',
            displayText: 'Rate Limits',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          {
            rank: 5,
            key: 'developers/whitelisting',
            displayText: 'Whitelisting',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
          // {
          //   rank: 6,
          //   key: 'developers/integration-usage',
          //   displayText: 'Integration Usage',
          //   isNew: false,
          //   isDisabled: false,
          //   isVisible: true,
          //   isParent: false,
          // },
          {
            rank: 7,
            key: 'developers/checkout-analytics',
            displayText: 'Checkout Analytics',
            isNew: false,
            isDisabled: false,
            isVisible: true,
            isParent: false,
          },
        ],
      },
    ],
  },
];

export const utilitiesItems = [];

export const keyKeyPGMapping = {
  paymentsforms: 'PF',
  'easysplit-vendor': 'CES',
  paymentlinks: 'ORDERS',
  softpos: 'EPOS',
  router: 'ROUTER',
};

export const ONLINE_OFFLINE_SETTLEMENTS_CHILDREN = [
  {
    rank: 1,
    key: 'settlements/online',
    displayText: 'Online',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
  {
    rank: 2,
    key: 'settlements/offline',
    displayText: 'Offline',
    isNew: false,
    isDisabled: false,
    isVisible: true,
    isParent: false,
  },
];

export const KEYBOARD_SHORTCUTS = {
  L: 'PAYMENT_LINK',
  P: 'PAYMENT_FORM',
  O: 'OFFER',
  B: 'PAYMENT_BUTTON',
  M: 'NO_COST_EMI',
};

export const REDIRECTION_MAPPER = {
  PAYMENT_LINK: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_LINKS.name
  }?createPaymentLink=true`,
  PAYMENT_BUTTON: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_BUTTONS.name
  }?createPaymentButton=true`,
  PAYMENT_FORM: `${
    PG_DASHBOARD_MENU_URL_MAPPING.PAYMENT_FORMS.name
  }?createPaymentForm=true`,
  OFFER: `${PG_DASHBOARD_MENU_URL_MAPPING.OFFERS}?createOffer=true`,
  NO_COST_EMI: `${PG_DASHBOARD_MENU_URL_MAPPING.OFFERS}?createNoCostEmi=true`,
};

export const DROPDOWN_OPTIONS = [
  {
    key: 1,
    text: 'Payment Link',
    description:
      'Create and send payment links instantly to your customers and collect payments.',
    value: 'PAYMENT_LINK',
    shortcutKey: 'L',
  },
  {
    key: 2,
    text: 'Payment Form',
    description:
      'Personalize the payment form to reflect your brand identity and start selling online.',
    value: 'PAYMENT_FORM',
    shortcutKey: 'P',
  },
  {
    key: 3,
    text: 'Payment Button',
    description:
      'Accept payments using Cashfree Payment button in a simple, safe, and secure manner.',
    value: 'PAYMENT_BUTTON',
    shortcutKey: 'B',
  },
  {
    key: 4,
    text: 'New Offer',
    description:
      'Create new offer and specify the offer details to create a unique offer for the customer.',
    value: 'OFFER',
    shortcutKey: 'O',
  },
  {
    key: 5,
    text: 'No Cost EMI',
    description:
      'Allow your customers to buy products in monthly instalments and need not pay any interest on the product purchased.',
    value: 'NO_COST_EMI',
    shortcutKey: 'M',
  },
];

export const DEVELOPERS_TOOL_HEADER_MAPPING = {
  'api-keys': 'API Keys',
  webhooks: 'Webhooks',
  'api-metrics': 'API Logs and Alerts',
  'rate-limits': 'Rate Limits',
  whitelisting: 'Whitelisting',
  'integration-usage': 'Integration Usage',
  'checkout-analytics': 'External Analytics',
};

export const DISPLAY_HEADER_MAPPING = {
  developers: 'Developer Tools',
};

export const INSIGHTS_AI_PATH = '/insights-ai';

export const FLOWWISE_GATEWAYS_PATH = '/gateways';

export const FLOWWISE_HOME_PATH = '/flowwise';

export const FLOWWISE_ANALYTICS_PATH = '/analytics';

export const DEFAULT_ACTIVE_SIDEBAR_ITEM = {
  'payment-links': 'payment-links/all',
  'payment-forms': 'payment-forms/all',
  'offers/offers-description': 'offers',
  'vba-configuration': 'vba-configuration/accounts',
  'one-click-checkout-activated':
    'one-click-checkout-activated/funnel-analytics',
  customers: 'customers/active',
  disputes: 'transactions/disputes',
  suspicious: 'transactions/suspicious',
  'analytics/conversion-rate': 'analytics',
  'analytics/business-trends': 'analytics',
  'analytics/payment-failure': 'analytics',
  'analytics/sr-dashboard': 'analytics',
  'customisation/business-customisation': 'customisation',
  'customisation/visual-customisation': 'customisation',
  'settlement-recon/': 'settlement-recon',
  'settlement-recon/uploaded-files': 'settlement-recon',
  'settlement-recon/settlement-recon-details': 'settlement-recon',
};

export const SUBPRODUCTS_FOR_PG_NOT_ENABLED = [
  'analytics',
  'transactions',
  'settlements-recon',
  'insights-ai',
  'reports',
  'developers',
];
